export const ZOOM_LEVELS = [1, 1.5, 2, 3];